module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h2', [_vm._v("Filtering")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('form-group', {
    attrs: {
      "label": "From",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    on: {
      "change": _vm.filterExpenses
    },
    model: {
      value: (_vm.filtering.dateFrom),
      callback: function($$v) {
        _vm.filtering.dateFrom = $$v
      },
      expression: "filtering.dateFrom"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "To",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    on: {
      "change": _vm.filterExpenses
    },
    model: {
      value: (_vm.filtering.dateTo),
      callback: function($$v) {
        _vm.filtering.dateTo = $$v
      },
      expression: "filtering.dateTo"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "User",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtering.user),
      expression: "filtering.user"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtering.user = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterExpenses]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Users")]), _vm._v(" "), _vm._l((_vm.$root.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Type",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtering.owner),
      expression: "filtering.owner"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtering.owner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setOwners]
    }
  }, [_c('option', {
    attrs: {
      "value": "Client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Project"
    }
  }, [_vm._v("Project")])])]), _vm._v(" "), (_vm.filtering.owner) ? _c('form-group', {
    attrs: {
      "label": _vm.filtering.owner,
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtering.owner_id),
      expression: "filtering.owner_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtering.owner_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterExpenses]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All " + _vm._s(_vm.filtering.owner) + "s")]), _vm._v(" "), _vm._l((_vm.owners), function(owner) {
    return _c('option', {
      domProps: {
        "value": owner.id
      }
    }, [_vm._v(_vm._s(_vm.filtering.owner == 'Client' ? owner.company : owner.project_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filtering.owner_id && _vm.filtering.owner == 'Client') ? _c('form-group', {
    attrs: {
      "label": "Location",
      "col-class": "col-md-4"
    },
    on: {
      "change": _vm.filterExpenses
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtering.location_id),
      expression: "filtering.location_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtering.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterExpenses]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Locations")]), _vm._v(" "), _vm._l((_vm.selectedClientLocations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  })], 2)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.expensesWithTokens), function(expense) {
    return _c('tr', {
      key: expense.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(expense.submitted_at, 'short')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.users.first_name) + " " + _vm._s(expense.users.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.owner_type == "client" ? expense.clients.company : expense.projects.project_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.locations && expense.owner_type == 'client' ? expense.locations.location_name : ''))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (expense.processed),
        expression: "expense.processed"
      }],
      staticStyle: {
        "height": "20px",
        "width": "20px"
      },
      attrs: {
        "type": "checkbox",
        "true-value": 1,
        "false-value": 0
      },
      domProps: {
        "checked": Array.isArray(expense.processed) ? _vm._i(expense.processed, null) > -1 : _vm._q(expense.processed, 1)
      },
      on: {
        "change": function($event) {
          _vm.updateProcessed(expense)
        },
        "__c": function($event) {
          var $$a = expense.processed,
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (expense.processed = $$a.concat($$v))
            } else {
              $$i > -1 && (expense.processed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            expense.processed = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": expense.receipt_link,
        "target": "_blank"
      }
    }, [_vm._v("View Receipt")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteExpense(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), _vm._v(" "), (_vm.expensesWithTokens.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n\t\t    \t\t\t\t\tNo Expenses found\n\t\t    \t\t\t\t")])]) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDeleteExpense(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDialog.message) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date Uploaded")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Client/Project")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Processed")]), _vm._v(" "), _c('th', [_vm._v("View")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27565780","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Expenses.vue
// module id = 278
// module chunks = 0